import { getLink } from '../../../../utils/utils';

import author from './author';
import esp from '../../../images/esperanto_almanah.png';

const content = {
	rus: (
		`
		
		<div style="text-align: justify;">
			<p class="mb-3">
				Да, конечно, эсперанто даёт базу, понимание общей структуры языка; и на этот каркас уже можно наращивать плоть любого национального языка. 
				Это называется «пропедевтическая ценность эсперанто», и эта тема в мире широко разрабатывается. 
				В Англии несколько лет назад проводился эксперимент «Языковой трамплин» по изучению эсперанто в начальной школе, 
				что помогало детям затем быстрее овладеть новым национальным языком, изучаемым в школе.
			</p>
			
			<p class="mb-3">
				Я сама проводила такой эксперимент в одесской школе № 39 в 1993-1994 учебном году в трёх параллелях третьих классов: 
				в одном из них я преподавала эсперанто факультативно, в другом так же факультативно преподавался английский язык: 
				в третьем никаких подготовительных занятий по языкам не проводилось. 
				В следующем учебном году во всех трёх классах началось официальное преподавание английского языка как обязательного школьного предмета, 
				и в конце этого года во всех трёх классах сделали срез знаний по английскому языку. 
				Оказалось, что лучшая успеваемость была в том классе, где преподавался эсперанто; на втором месте оказался класс, 
				где не было никакой специальной языковой подготовки; и на третьем – тот, где с детьми подготовительно занимались английским… 😄
			</p>
			
			<p class="mb-3">
				Но вернёмся к вашим вопросам о полиглотах. 
				Английский я после школы знала неплохо, читала на нём, говорила… но в мою жизнь как что-то важное он не входил. 
				Совсем иначе обстояло дело с эсперанто, в живую атмосферу которого я погрузилась после третьего курса Университета в языковом лагере 
				(подробнее об этом я пишу в книге «Лучшие дни нашей жизни» - <a href="https://reu.ru/prenu/luchshije_dni.pdf" target="_blank" download>Скачать</a>)
			</p>
			
			<p class="mb-3">
				И понеслось… Вернувшись домой, я тут же записалась на Чкаловские курсы, чтобы выучить испанский - язык с лексикой, 
				основанной на латыни – чтоб не так страшно было взяться за совсем новое дело. 
				И оказалось, что этот язык будто был создан специально для меня – так легко и свободно он укладывался в голове. 
			</p>
			
			<p class="mb-3">
				Осмелев, я пошла и на курсы немецкого: а вдруг всё так хорошо идёт потому, что корни близки, языки родственны, 
				- а ну как будет дело с языком другой языковой группы, да ещё не вызывающим симпатии (мне немецкий казался тогда грубым и некрасивым). 
				Надо же, и немецкий поддался!
			</p>
			
			<p class="mb-3">
				Но нужно отметить, что я категорически делаю различие между «знать язык» и «говорить на языке». 
				Почему-то считается, что «знать» - это и есть говорить. 
				Но говорю я со всем миром на эсперанто; мне не нужно выучивать десятки языков, чтобы говорить с китайцами, японцами, чехами, бельгийцами, 
				индийцами – со всеми я говорю на языке, общем для всех, международном языке эсперанто. 
			</p>
			
			<p class="mb-3">
				А вот читать – это другое дело. 
				Читать оригинальную литературу на том языке, на котором писал автор, воспринимая его стиль и все нюансы мысли; понимать в чужой стране надписи, 
				указатели, вывески, этикетки на товарах, наконец – это в самом деле и приятно, и полезно, и необходимо.
			</p>
			
			<p class="mb-3">
				Так что понимать прочитанное я могу на многих языках. 
				Здесь как разматывается клубок: знаешь русский и украинский – поймёшь и польский; за ним – и другие славянские языки. 
				Знаешь испанский, эсперанто, латынь – поймёшь и итальянский, и португальский, и французский. 
				Знание английского и немецкого помогает даже догадываться о смысле датских и шведских текстов… 
				Но разумеется, речь идёт опять-таки о понимании написанного текста, а не о разговоре. 
				Ведь написание во многих европейских языках, особенно в английском и французском, часто совершенно не совпадает с произношением. 
				Написание остаётся архаичным, в нём можно угадать латинские корни, общие для многих языков, 
				а разговорная речь изменяется по историческим меркам гораздо быстрее. 
				Вот и доизменялась так, что в английском, например, невозможно написать незнакомое слово without spelling (не называя его по буквам). 
				Таким образом, изучая английский язык, мы фактически учим три предмета: английский письменный, английский устный и систему взаимоотношений между ними. 
				То ли дело эсперанто, где говорится, как пишется, а пишется, как слышится! 
				Вместо трёх предметов ты изучаешь только один, и это оставляет свободными огромные резервы памяти для изучения лексики, основного тела языка. 
				Но это я уже опять села на любимого конька… 😄
			</p>
			
			<p class="mb-3">
				Один мой знакомый недавно написал, что в юности поставил себе задачу: каждый год выучивать по одному новому языку. 
				Сейчас он уже знает их больше десятка; но юность, к сожалению, прошла, и сейчас выучивать новое не так просто. 
				Так что лиха беда – начало! 
				Начните, пока вы молоды, пока мозги эластичны и легко впитывают новое. 
				Как говорили в проклятую советскую эпоху: «Дерзайте! Вы талантливы!».
			</p>
			
			<p class="mb-3 text-center">
				<img src=${esp} alt="Альманах Эсперанто" />
			</p>
				
		</div>
		`
	)
}

const itemName = {
	rus: `К вопросу о полиглотах`
}

const item = {
	itemlink: getLink(itemName.rus),
	rus: {
		itemName: itemName.rus,
		itemContent: content.rus,
		itemAuthor: author.rus
	}
}

export default item;